<template>
  <div>
    <v-row align="start">
      <v-col cols="12">
        <v-banner icon="mdi-map-marker">
          Delivery Addresses
          <template v-slot:actions>
            <v-btn
              color="success"
              :to="{
                name: 'DeliveryAddressForm',
                params: { isNew: true, data: {} },
              }"
            >
              <v-icon left>add_circle_outline</v-icon> Add Address
            </v-btn>
            <v-btn
              v-if="showBack"
              text
              color="blue darken-2"
              exact
              @click="$router.go(-1)"
            >
              <v-icon left>arrow_back</v-icon>Back
            </v-btn>
          </template>
        </v-banner>
      </v-col>
    </v-row>
    <v-row v-if="!showConversionPrompt" class="fill-height" align="stretch">
      <v-col v-if="accountType != 'C1'" cols="12" class="pb-0">
        <v-form @submit.prevent ref="deliveryAddressesSearchForm">
          <v-text-field
            :loading="loading"
            v-model="search"
            ref="search"
            :rules="searchRules"
            placeholder="Address Search"
            filled
            clearable
            @input="debounceSearch"
          >
            <template slot="append">
              <v-btn
                type="submit"
                icon
                class="mr-0 ml-2 mb-1 p-0"
                style="margin-top: -6px"
                @click="searchAddresses()"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </template>
          </v-text-field>
        </v-form>
      </v-col>

      <v-col
        v-if="addresses.length > 0"
        cols="12"
        style="max-height: 400px"
        class="py-0 overflow-y-auto"
      >
        <v-row class="fill-height" align="stretch">
          <v-col cols="12"> {{ addresses.length }} Addresses Found </v-col>

          <v-col
            cols="12"
            md="4"
            v-for="(address, index) in addresses"
            :key="index"
          >
            <ViewAddress :data="address" />
          </v-col>
        </v-row>
      </v-col>

      <v-col v-else cols="12"> Search to find saved Addresses </v-col>
    </v-row>

    <v-row v-if="showConversionPrompt" align="stretch" style="height: 100%">
      <v-col cols="12"> <ConvertAddress /> </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ViewAddress from "@/components/deliveryAddresses/View.vue";
import ConvertAddress from "@/components/deliveryAddresses/Convert.vue";

export default {
  props: {
    showBack: Boolean,
  },

  components: {
    ViewAddress,
    ConvertAddress,
  },

  data: () => ({
    loading: false,
    showConversionPrompt: false,

    search: null,
    searchRules: [
      (v) => (v && v.length > 0) || "Please enter a search term",
      (v) => /^[a-zA-Z0-9 ]*$/.test(v) || "Search must be alphanumeric only",
    ],
  }),

  async activated() {
    await this.refreshUserAddresses();
  },

  computed: {
    addresses() {
      return this.$store.getters.retrieveAddresses;
    },

    accountType() {
      return this.$store.getters.retrieveAdmin.account_type;
    },
  },

  methods: {
    ...mapActions([
      "searchDeliveryAddresses",
      "getUserDeliveryAddresses",
      "convertUserDeliveryAddress",
    ]),

    debounceSearch() {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.searchAddresses();
      }, 600);
    },

    async searchAddresses() {
      this.loading = true;
      let addressResponse = await this.searchDeliveryAddresses(this.search);

      if (addressResponse) {
        if (addressResponse.success) {
          //
        } else {
          //
        }
      } else {
        //No Response at all so do nothing
      }

      this.loading = false;
    },

    async refreshUserAddresses() {
      this.loading = true;

      console.log("Data");
      console.log(this.$store.getters.retrieveAdmin);

      if (this.accountType == "C1") {
        let addressResponse = await this.getUserDeliveryAddresses();

        if (addressResponse) {
          if (addressResponse.success) {
            this.showConversionPrompt = false;
          } else {
            let convertResponse = await this.convertUserDeliveryAddress();
            console.log(convertResponse);

            if (convertResponse != false) {
              await this.getUserDeliveryAddresses();
            }

            // this.showConversionPrompt = true;
          }
        } else {
          //No Response at all so do nothing
        }
      } else {
        //We're an A1 or D1 Customer so don't auto-load our addresses
      }

      this.loading = false;
    },
  },
};
</script>

<style lang="sass" scoped>
::-webkit-scrollbar-track
  border-radius: 16px
</style>